import { FC, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { fetchAllProducts } from "../redux";
import Spinner from "../components/Spinner";
import Alert from "../components/Alert";

interface ProductType {
  id: number;
  name: string;
  category: {
    name: string;
  };
  supplier: {
    name: string;
  };
  quantity: number;
  buying_price: number;
  selling_price: number;
  offer_status: string;
  volume: number;
  image_url: string;
  updated_at: string;
}

const AllProducts: FC = (props: any) => {
  const { fetchAllProducts } = props;
  const [products, setProducts] = useState<ProductType[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const handleAsync = async () => {
      fetchAllProducts((res: any) => {
        const { data, status } = res;
        setIsLoading(false);
        if (status === "info") {
          setProducts(data);
        }

        if (status === "error") {
          setStatus("error");
          const { message } = res;
          setMessage(message);
        }
      });
    };
    handleAsync();
    // eslint-disable-next-line
  }, []);

  setTimeout(() => {
    setStatus("");
    setMessage("");
  }, 2000);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <section>
          {status !== "" && <Alert status={status} message={message} />}

          <nav id="store" className="w-full top-0 px-6 py-1">
            <div className="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 px-2 py-3">
              <Link
                className="uppercase tracking-wide no-underline hover:no-underline font-bold text-gray-800 text-xl "
                to="#"
              >
                All Products
              </Link>
              <div className="flex items-center" id="store-nav-content">
                <Link
                  className="pl-3 inline-block no-underline hover:text-black"
                  to="#"
                >
                  <svg
                    className="fill-current hover:text-black"
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                  >
                    <path d="M7 11H17V13H7zM4 7H20V9H4zM10 15H14V17H10z" />
                  </svg>
                </Link>
                <Link
                  className="pl-3 inline-block no-underline hover:text-black"
                  to="#"
                >
                  <svg
                    className="fill-current hover:text-black"
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                  >
                    <path d="M10,18c1.846,0,3.543-0.635,4.897-1.688l4.396,4.396l1.414-1.414l-4.396-4.396C17.365,13.543,18,11.846,18,10 c0-4.411-3.589-8-8-8s-8,3.589-8,8S5.589,18,10,18z M10,4c3.309,0,6,2.691,6,6s-2.691,6-6,6s-6-2.691-6-6S6.691,4,10,4z" />
                  </svg>
                </Link>
              </div>
            </div>
          </nav>

          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-4 lg:items-start">
              <div className="lg:top-4">
                <details
                  open
                  className="overflow-hidden border border-gray-200 rounded"
                >
                  <summary className="flex items-center justify-between px-5 py-3 bg-gray-100 lg:hidden">
                    <span className="text-sm font-medium">Toggle Filters</span>
                    <svg
                      className="w-5 h-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  </summary>
                  <form
                    action=""
                    className="border-t border-gray-200 lg:border-t-0"
                  >
                    <fieldset>
                      <legend className="block w-full px-5 py-3 text-xs font-medium bg-gray-50">
                        Type
                      </legend>
                      <div className="px-5 py-6 space-y-2">
                        <div className="flex items-center">
                          <input
                            id="toy"
                            type="checkbox"
                            name="type[toy]"
                            className="w-5 h-5 border-gray-300 rounded"
                          />
                          <label
                            htmlFor="toy"
                            className="ml-3 text-sm font-medium"
                          >
                            Beer
                          </label>
                        </div>
                        <div className="flex items-center">
                          <input
                            id="game"
                            type="checkbox"
                            name="type[game]"
                            className="w-5 h-5 border-gray-300 rounded"
                          />
                          <label
                            htmlFor="game"
                            className="ml-3 text-sm font-medium"
                          >
                            Whiskey
                          </label>
                        </div>
                        <div className="flex items-center">
                          <input
                            id="outdoor"
                            type="checkbox"
                            name="type[outdoor]"
                            className="w-5 h-5 border-gray-300 rounded"
                          />
                          <label
                            htmlFor="outdoor"
                            className="ml-3 text-sm font-medium"
                          >
                            Gin
                          </label>
                        </div>
                        <div className="pt-2">
                          <button
                            type="button"
                            className="text-xs text-gray-500 underline"
                          >
                            Reset Type
                          </button>
                        </div>
                      </div>
                    </fieldset>
                    <div>
                      <fieldset>
                        <legend className="block w-full px-5 py-3 text-xs font-medium bg-gray-50">
                          Volume
                        </legend>
                        <div className="px-5 py-6 space-y-2">
                          <div className="flex items-center">
                            <input
                              id="3+"
                              type="checkbox"
                              name="age[3+]"
                              className="w-5 h-5 border-gray-300 rounded"
                            />
                            <label
                              htmlFor="3+"
                              className="ml-3 text-sm font-medium"
                            >
                              1 Litre
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              id="8+"
                              type="checkbox"
                              name="age[8+]"
                              className="w-5 h-5 border-gray-300 rounded"
                            />
                            <label
                              htmlFor="8+"
                              className="ml-3 text-sm font-medium"
                            >
                              750 ML
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              id="12+"
                              type="checkbox"
                              name="age[12+]"
                              className="w-5 h-5 border-gray-300 rounded"
                            />
                            <label
                              htmlFor="12+"
                              className="ml-3 text-sm font-medium"
                            >
                              375 ML
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              id="16+"
                              type="checkbox"
                              name="age[16+]"
                              className="w-5 h-5 border-gray-300 rounded"
                            />
                            <label
                              htmlFor="16+"
                              className="ml-3 text-sm font-medium"
                            >
                              250 ML
                            </label>
                          </div>
                          <div className="pt-2">
                            <button
                              type="button"
                              className="text-xs text-gray-500 underline"
                            >
                              Reset Volume
                            </button>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                    <div className="flex justify-between px-5 py-3 border-t border-gray-200">
                      <button
                        name="reset"
                        type="button"
                        className="text-xs font-medium text-gray-600 underline rounded"
                      >
                        Reset All
                      </button>
                      <button
                        name="commit"
                        type="button"
                        className="px-5 py-3 text-xs font-medium text-white bg-green-600 rounded"
                      >
                        Apply Filters
                      </button>
                    </div>
                  </form>
                </details>
              </div>
              <div className="lg:col-span-3">
                <div className="flex items-center justify-between">
                  <p className="text-sm text-gray-500">
                    {/* <span className="hidden sm:inline">Showing</span>6 of 24 */}
                    Products
                  </p>
                  <div className="ml-4">
                    <label htmlFor="SortBy" className="sr-only">
                      Sort
                    </label>
                    <select
                      id="SortBy"
                      name="sort_by"
                      className="text-sm border-gray-100 rounded"
                    >
                      <option value="">Sort</option>
                      <option value="title-asc">Title, A-Z</option>
                      <option value="title-desc">Title, Z-A</option>
                      <option value="price-asc">Price, Low-High</option>
                      <option value="price-desc">Price, High-Low</option>
                    </select>
                  </div>
                </div>
                <div className="container mx-auto flex items-center flex-wrap pt-4 pb-12">
                  <>
                    {products.map((product: ProductType, i: number) => (
                      <div
                        className="mb-4 w-full md:w-1/3 xl:w-1/3 p-2 flex flex-col"
                        key={i}
                      >
                        <button
                          type="button"
                          name="wishlist"
                          className="absolute p-1 text-white bg-black hover:bg-red-500 rounded-full right-4 top-4"
                        >
                          <svg
                            className="h-5 w-5 fill-current text-green-500 hover:text-black"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M12,4.595c-1.104-1.006-2.512-1.558-3.996-1.558c-1.578,0-3.072,0.623-4.213,1.758c-2.353,2.363-2.352,6.059,0.002,8.412 l7.332,7.332c0.17,0.299,0.498,0.492,0.875,0.492c0.322,0,0.609-0.163,0.792-0.409l7.415-7.415 c2.354-2.354,2.354-6.049-0.002-8.416c-1.137-1.131-2.631-1.754-4.209-1.754C14.513,3.037,13.104,3.589,12,4.595z M18.791,6.205 c1.563,1.571,1.564,4.025,0.002,5.588L12,18.586l-6.793-6.793C3.645,10.23,3.646,7.776,5.205,6.209 c0.76-0.756,1.754-1.172,2.799-1.172s2.035,0.416,2.789,1.17l0.5,0.5c0.391,0.391,1.023,0.391,1.414,0l0.5-0.5 C14.719,4.698,17.281,4.702,18.791,6.205z" />
                          </svg>
                        </button>

                        <Link to={`/product/view/${product.id}`}>
                          <img
                            className="hover:grow hover:shadow-lg rounded"
                            src={product.image_url}
                            alt={product.name}
                          />
                          <div className="pt-3 flex items-center justify-between">
                            <p>{product && product.name}</p>
                            <button className="inline-flex bg-black text-xs rounded px-3 py-2 items-center  tracking-wider transition-colors duration-200 text-white hover:bg-green-400">
                              Add to cart
                              <svg
                                className="w-4 h-4 ml-1.5"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                                />
                              </svg>
                            </button>
                          </div>
                          <p className="pt-1 text-gray-900">{`Ksh. ${
                            product && product.selling_price
                          }`}</p>
                        </Link>
                      </div>
                    ))}
                  </>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchAllProducts: (callbackfunction: any) =>
      dispatch(fetchAllProducts(callbackfunction)),
  };
};

export default connect(null, mapDispatchToProps)(AllProducts);
